import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { RoleGuard } from './guards/roleGuard';
import { environment } from 'src/environments/environment';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () =>
      import('./login/login.component').then((m) => m.LoginComponent),
    data: { title: 'Login' }
  },
  {
    path: '',
    loadComponent: () =>
      import('./home/home.component').then((m) => m.HomeComponent),
    canActivate: [MsalGuard],
    data: { title: 'Dashboard' }
  },
  {
    path: 'time',
    loadComponent: () =>
      import('./time/timelog.component').then((m) => m.TimelogComponent),
    canActivate: [MsalGuard, RoleGuard],
    data: { 
      expectedRoles: [environment.roles.invoicer, environment.roles.timeTracker], 
      title: 'Timesheet' 
    },
  },
    {
    path: 'report',
    loadComponent: () =>
      import('./reports/reports.component').then((m) => m.ReportsComponent),
    canActivate: [MsalGuard, RoleGuard],
    data: { 
      expectedRoles: [environment.roles.invoicer], 
      title: 'Report' 
    },
  },
  {
    path: 'clients',
    loadComponent: () =>
      import('./clients/clients.component').then((m) => m.ClientsComponent),
    canActivate: [MsalGuard, RoleGuard],
    data: { 
      expectedRoles: [environment.roles.invoicer], 
      title: 'Clients' 
    },
  },
  {
    path: 'client',
    loadComponent: () =>
      import('./clients/client-details/client-details.component').then((m) => m.ClientDetailsComponent),
    canActivate: [MsalGuard, RoleGuard],
    data: { 
      expectedRoles: [environment.roles.invoicer], 
      title: 'New Client' 
    },
  },
  {
    path: 'client/:id',
    loadComponent: () =>
      import('./clients/client-details/client-details.component').then((m) => m.ClientDetailsComponent),
    canActivate: [MsalGuard, RoleGuard],
    data: { 
      expectedRoles: [environment.roles.invoicer], 
      title: 'Client' 
    },
  },

  {
    path: 'services',
    loadComponent: () =>
      import('./services/services.component').then((m) => m.ServicesComponent),
    canActivate: [MsalGuard, RoleGuard],
    data: { 
      expectedRoles: [environment.roles.invoicer], 
      title: 'Services' 
    },
  },
  {
    path: 'service',
    loadComponent: () =>
      import('./services/service-details/service-details.component').then(
        (m) => m.ServiceDetailsComponent
      ),
      canActivate: [MsalGuard, RoleGuard],
      data: { 
        expectedRoles: [environment.roles.invoicer], 
        title: 'New Service' 
      },
  },
  {
    path: 'service/:id',
    loadComponent: () =>
      import('./services/service-details/service-details.component').then(
        (m) => m.ServiceDetailsComponent
      ),
      canActivate: [MsalGuard, RoleGuard],
      data: { 
        expectedRoles: [environment.roles.invoicer], title: 'Service' 
      },
  },

  {
    path: 'users',
    loadComponent: () =>
      import('./users/users.component').then((m) => m.UsersComponent),
    canActivate: [MsalGuard, RoleGuard],
    data: { 
      expectedRoles: [environment.roles.invoicer], 
      title: 'Users' 
    },
  },

  {
    path: 'user/:id',
    loadComponent: () =>
      import('./users/users-tab/user-details/user-details.component').then(
        (m) => m.UserDetailsComponent
      ),
      canActivate: [MsalGuard, RoleGuard],
      data: { 
        expectedRoles: [environment.roles.invoicer], 
        title: 'User' 
      },
  },

  {
    path: 'team',
    loadComponent: () =>
      import('./users/teams-tab/team-details/team-details.component').then(
        (m) => m.TeamDetailsComponent
      ),
      canActivate: [MsalGuard, RoleGuard],
      data: { 
        expectedRoles: [environment.roles.invoicer], 
        title: 'New Team' 
      },
  },
  {
    path: 'team/:id',
    loadComponent: () =>
      import('./users/teams-tab/team-details/team-details.component').then(
        (m) => m.TeamDetailsComponent
      ),
      canActivate: [MsalGuard, RoleGuard],
      data: { 
        expectedRoles: [environment.roles.invoicer], 
        title: 'Team' 
      },
  },

  {
    path: 'availabilities',
    loadComponent: () =>
      import('./availability/availability.component').then((m) => m.AvailabilityComponent),
    canActivate: [MsalGuard, RoleGuard],
    data: { 
      expectedRoles: [environment.roles.invoicer, environment.roles.timeTracker], 
      title: 'Availability' 
    },
  },
  {
    path: 'availability',
    loadComponent: () =>
      import('./availability/availability-details/availability-details.component').then(
        (m) => m.AvailabilityDetailsComponent
      ),
      canActivate: [MsalGuard, RoleGuard],
      data: { 
        expectedRoles: [environment.roles.invoicer, environment.roles.timeTracker], 
        title: 'New Availability' 
      },
  },
  {
    path: 'availability/:id',
    loadComponent: () =>
      import('./availability/availability-details/availability-details.component').then(
        (m) => m.AvailabilityDetailsComponent
      ),
      canActivate: [MsalGuard, RoleGuard],
      data: { 
        expectedRoles: [environment.roles.invoicer, environment.roles.timeTracker], 
        title: 'Availability' 
      },
  },

  {
    path: 'default-working-location',
    loadComponent: () =>
      import('./availability/default-working-location/default-working-location.component').then(
        (m) => m.DefaultWorkingLocationComponent
      ),
    canActivate: [MsalGuard, RoleGuard],
    data: { 
      expectedRoles: [environment.roles.timeTracker], 
      title: 'Default Working Location'
    },
  },

  {
    path: 'forecasts',
    loadComponent: () =>
      import('./forecast/forecast.component').then((m) => m.ForecastComponent),
    canActivate: [MsalGuard, RoleGuard],
    data: { 
      expectedRoles: [environment.roles.invoicer, environment.roles.forecaster, environment.roles.timeTracker], 
      title: 'Forecast'
    },
  },

  { path: '**', component: PageNotFoundComponent },
];